import { useCallback, useState } from 'react';
import { isNil } from 'lodash';
import { Calibration } from 'common/types/valuation/valuation';
import { NoteData } from 'components/Notes/types';
import { getStringValue } from 'utilities';
import { Note } from '../../types';
import { useSavePanelNotes } from '../useSavePanelNotes/useSavePanelNotes';

interface SaveNotesOptions {
  onSuccess?: (savedNotes: NoteData[]) => void;
  onSettled?: () => void;
}

interface UseCalibrationNotesParams {
  calibrations?: Calibration[];
  notesSaveInFlightByPanelRef: { current: Set<string> };
  saveNotes: (notesData?: NoteData[], options?: SaveNotesOptions) => void;
}

export const useCalibrationNotes = (params: UseCalibrationNotesParams) => {
  const { calibrations, notesSaveInFlightByPanelRef, saveNotes } = params;
  const [notesInCalibration, setNotesInCalibration] = useState<Note[]>([]);

  const canSaveCalibrationPanel = useCallback(
    (panelId: string) => {
      const calibration = calibrations?.find(
        currentCalibration => getStringValue(currentCalibration?.panel_id ?? currentCalibration?.panelId) === panelId
      );
      return !isNil(calibration?.id);
    },
    [calibrations]
  );

  const { savePanelNotes: saveCalibrationNotes } = useSavePanelNotes({
    canSavePanel: canSaveCalibrationPanel,
    notes: notesInCalibration,
    notesSaveInFlightByPanelRef,
    saveNotes,
    setNotes: setNotesInCalibration,
  });

  return {
    notesInCalibration,
    saveCalibrationNotes,
    setNotesInCalibration,
  };
};
